import i18n from '@/utils/i18n';
import React from 'react';
import WheyImage from '@assets/icons/whey.svg';
import { createStyles } from '@/contexts/theme-context';
import { EmptyStateMinimal } from '@/components/empty-state-minimal';
import { SCREEN_PADDING } from '@/styles';
import { ScrollView, StyleSheet } from 'react-native';

export const ChatEmptyCard: React.FC = () => {
  const [styles] = useStyles();

  return (
    <ScrollView
      alwaysBounceVertical={false}
      contentContainerStyle={styles.scrollViewContent}
      style={StyleSheet.absoluteFill}
    >
      <EmptyStateMinimal
        containerStyle={styles.emptyStateContainer}
        ImageComponent={WheyImage}
        text={i18n.t('chat.empty_message')}
      />
    </ScrollView>
  );
};

const useStyles = createStyles((theme) => ({
  emptyStateContainer: {
    backgroundColor: theme.colors.white,
  },
  scrollViewContent: {
    // Set flexGrow so it can still scroll when it overflows its container
    flexGrow: 1,
    justifyContent: 'center',
    paddingBottom: SCREEN_PADDING,
    paddingHorizontal: SCREEN_PADDING,
    paddingTop: 24,
  },
}));
